import { settings } from 'src/app/shared/settings';

export function unlocalizedURL(url: string) {
  const splitURL = url.split('/');
  if (settings.SUPPORTED_LANGUAGES.includes(splitURL[3])) {
    splitURL.splice(3, 1);
  }
  return splitURL.join('/');
}
